import { Component, OnInit } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { MatDialog } from '@angular/material/dialog';
import { BalancesService } from '../../services/balances.services';
import { TaxReClaimResponse } from '../../model/taxreclaim-response.model';
import { formatDate } from '@angular/common';
import { BalancesExportUtil } from '../../utils/balances-export-util';
import { GridExportService } from '@pershing/nxi-common';
import { BalancesConstants } from '../../utils/balances-constants';
import { BalancesCommonUtils } from '../../utils/balances-utils';

@Component({
    selector: 'tax-reclaim-receivables',
    templateUrl: './tax-reclaim-receivables.component.html'
})
export class TaxReclaimReceivablesComponent implements OnInit {

    header: string = 'Tax Reclaim Receivables';
    theme: string = 'standard';
    taxReClaimData: any;
    TaxReClaimResponseSub: any;
    today= new Date();
    todaysDate = '';
    isLoading: boolean = true;
    balancesServiceErrorSub: any;
    balancesResponseSub: any;
    balancesResponseErrorSub: any;
    fetchingBalancesDataSub: any;
    SystemErrorMsg: string;
    noDataFound: boolean;
     //download excel
     totalRowCount: number = 2;
     gridBalancesExport: any;
     downloadExtension: string = '';
    constructor(
        private translationService: PershingTranslationService,
        private dialog: MatDialog,
        private balancesService: BalancesService,
        private gridExportService: GridExportService,
        private commonUtils: BalancesCommonUtils
    ) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-balances', 'node_modules/@pershing/nxi-ng-balances/lib');
        this.todaysDate = formatDate(this.today, 'MM/dd/yyyy', 'en-US', '+0530');
    }

    ngOnInit() {
        this.balancesServiceErrorSub = this.balancesService.balancesServiceError$.subscribe(error => {
            this.SystemErrorMsg = !!error && !!error.errorMessage ? error.errorMessage : '';
            this.isLoading = false;
        });

        // Got BalancesResponse but has 'errorCode' of non-zero.
        this.balancesResponseErrorSub = this.balancesService.balancesResponseError$.subscribe(error => {
            this.SystemErrorMsg = !!error && !!error.errorMessage ? error.errorMessage : '';
            this.isLoading = false;
        });

        // loading
        this.fetchingBalancesDataSub = this.balancesService.fetchingBalancesData$.subscribe(fetching => {
            this.isLoading = !!fetching ? fetching : false;
        });
       this.TaxReClaimResponseSub = this.balancesService.taxreclaimResponse$.subscribe(data => {
        if (!!data && !!data.response) {
            this.processTaxReClaimData(data);
        }
    });
    }
    processTaxReClaimData(data: TaxReClaimResponse) {
        if (!!data && !!data.response) {
            if (data.response.returnCode === '00') {
                this.noDataFound = true;
                this.taxReClaimData = data.response.taxReclaimDetail;
            } else {
                this.noDataFound = false;
            }
            
        }
    }
    ngOnDestroy(): void {
        
        if (this.balancesServiceErrorSub) {
            this.balancesServiceErrorSub.unsubscribe();
        }
        if (this.balancesResponseErrorSub) {
            this.balancesResponseErrorSub.unsubscribe();
        }
        if (this.TaxReClaimResponseSub) {
            this.TaxReClaimResponseSub.unsubscribe();
        }
        if (this.fetchingBalancesDataSub) {
            this.fetchingBalancesDataSub.unsubscribe();
        }
    }
    closeDialog() {
        this.dialog.closeAll();
    }
    onExportClicked(event: any): void {
        let rowData;
        rowData = this.processTaxReClaim(this.taxReClaimData);
        console.log('Export', rowData);
        this.totalRowCount = rowData.length;
        if ( event === 'exporttoexcel') {
            this.downloadExtension = 'xlsx';
            const exportConfig = this.getExportConfig();
            this.gridExportService.initiateExportCallWithJSONData(JSON.stringify({'response': {'balances': {'data': rowData}}}), exportConfig, this.downloadExtension);
        }
        if (event === 'print') {
            window.print();
        }
    }

    getExportConfig(): any {
        const exportConfig = {};
        exportConfig['title'] = BalancesConstants.TAXRECLAIM + " " + this.todaysDate;
        exportConfig['columnInfoList'] = BalancesExportUtil.getTaxReClaimColList();
        exportConfig['dataListIdentifier'] = 'response.balances.data';
        exportConfig['childListIdentifier'] = 'children';
        exportConfig['groupSingleChildren'] = 'true';
        exportConfig['summaryIdentifiers'] = this.processSummaryIdentifers();
        return exportConfig;
    }
    processTaxReClaim(taxReclaimData: any) {
        let taxReceiveData = this.commonUtils.numberPipeTransform(taxReclaimData);
        console.log('taxReceiveData', taxReceiveData);
        return taxReceiveData;
    }
    processSummaryIdentifers(){
        return [ {
                displayName: "Account Number",
                value: this.balancesService.getAccountContext()
            },
            {
                displayName: "Account Name",
                value: ''
            }
        ];
    }
}
